import React, { useEffect, useState } from "react";
import { Alert } from "reactstrap";
import { Link } from "react-router-dom";
import { api as apiCfg } from "../../config";

/**
 * Phase 5.1 — Payment status banner.
 * Reads `/api/feature-flags` once on mount; renders only when the user is in
 * GRACE or EXPIRED billing state. Cached in sessionStorage to avoid flashes.
 */
const BillingBanner = () => {
  const [status, setStatus] = useState(null);
  const [graceUntil, setGraceUntil] = useState(null);

  useEffect(() => {
    let alive = true;
    const apply = (data) => {
      if (!alive || !data) return;
      setStatus(data.paymentStatus || null);
      setGraceUntil(data.gracePeriodUntil || null);
    };

    try {
      const cached = sessionStorage.getItem("featureFlagsResponse");
      if (cached) apply(JSON.parse(cached));
    } catch (_) { /* ignore */ }

    const authUserRaw = sessionStorage.getItem("authUser");
    if (!authUserRaw) return;
    let token = null;
    try { token = JSON.parse(authUserRaw)?.token; } catch (_) { return; }
    if (!token) return;

    const apiBase = (apiCfg?.API_URL || "http://localhost:8080/api").replace(/\/$/, "");
    fetch(`${apiBase}/feature-flags`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (!data) return;
        try { sessionStorage.setItem("featureFlagsResponse", JSON.stringify(data)); } catch (_) {}
        apply(data);
      })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  if (!status || status === "PAID") return null;

  const daysLeft = graceUntil
    ? Math.max(0, Math.ceil((new Date(graceUntil) - Date.now()) / 86400000))
    : 0;

  if (status === "GRACE") {
    return (
      <Alert color="warning" className="mb-0 rounded-0 text-center">
        <i className="ri-alarm-warning-line me-2" />
        Your plan has expired. You're in a {daysLeft}-day grace period — write actions are paused.{" "}
        <Link to="/billing"><b>Renew now →</b></Link>
      </Alert>
    );
  }
  return (
    <Alert color="danger" className="mb-0 rounded-0 text-center">
      <i className="ri-error-warning-line me-2" />
      Your subscription has ended. <Link to="/billing"><b>Reactivate to resume sending →</b></Link>
    </Alert>
  );
};

export default BillingBanner;
